<template>

    <nav class="main-nav">
        <div class="main-nav-container">
            <div class="main-nav-left">
                <router-link to="/" class="main-nav-logo">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         viewBox="0 0 530 259.14">
                        <defs>
                            <clipPath id="a" transform="translate(0 0)">
                                <path d="M125.16,106.78h52.66A56.39,56.39,0,0,1,189.34,96L144.23,80.54a172.29,172.29,0,0,0-19.07,26.24m207.13-6.35a34.54,34.54,0,0,1-.11,6.35h94.61a96.35,96.35,0,0,0-3.21-39.38ZM161.69,62.49l46.18,22.83a162.37,162.37,0,0,1,17.83-7L190.56,39.2a258.38,258.38,0,0,0-28.87,23.29m153,14.29a34.31,34.31,0,0,1,12,9.12l80-48.83c-10.39-11.8-24.53-21.21-42.06-27.6ZM217.94,22.63,247.21,72.7c4.57-.88,9.16-1.58,13.71-2.08L250.34,9a216.92,216.92,0,0,0-32.4,13.59M305.3,0a166.5,166.5,0,0,0-21.17,1.39L279.81,69.8A118.16,118.16,0,0,1,294,70.93L326.16,1A207.49,207.49,0,0,0,305.3,0Z"
                                      style="fill:none"/>
                            </clipPath>
                        </defs>
                        <title>logo (2)</title>
                        <g style="clip-path:url(#a)">
                            <rect x="125.16" width="303.26" height="106.78" style="fill:#fff"/>
                        </g>
                        <path d="M452.8,165.65c-5.56,0-8.54-1.91-8.54-5.31s2.65-5.15,8-5.48l12.2-.66v10.53a86.35,86.35,0,0,1-11.7.92m3.49-34.34a90.08,90.08,0,0,0-17.09,1.82l1,8.05a101.27,101.27,0,0,1,15.35-1.5c5.81,0,9,2.16,9,6.89v.49l-11.53.67c-12,.5-17.75,4.56-17.75,12.36,0,8.54,5.39,13.27,15.26,13.27,5.06,0,9,0,22.89-2.07v-25c0-10.29-5.47-15-17.08-15m-47.29.33a55.1,55.1,0,0,0-16.67,2.57c-2.82-1.83-6.55-2.57-10.95-2.57a114.43,114.43,0,0,0-20.48,2.07V172.1h9.53V140.93a64.29,64.29,0,0,1,8.88-.58c6.14,0,9.12,2.73,9.12,9.12v22.65h9.63v-25.3a19.25,19.25,0,0,0-.67-5.23,34.2,34.2,0,0,1,9.54-1.24c6.14,0,9.13,3.07,9.13,9.29v22.48h9.54V146.9c0-11-6.64-15.26-16.6-15.26m-81.7,34c-5.55,0-8.54-1.91-8.54-5.31s2.65-5.15,8-5.48l12.2-.66v10.53a86.35,86.35,0,0,1-11.7.92m3.49-34.34a90.08,90.08,0,0,0-17.09,1.82l1,8a101.27,101.27,0,0,1,15.35-1.5c5.81,0,9,2.16,9,6.89v.49l-11.53.67c-12,.5-17.75,4.56-17.75,12.36,0,8.54,5.39,13.27,15.26,13.27,5.06,0,9,0,22.89-2.07v-25c0-10.29-5.47-15-17.08-15m-49.36,33.17a56.19,56.19,0,0,1-11.36-.83v-23.3a80.23,80.23,0,0,1,10.62-.67c8.46,0,11.69,5.48,11.69,12.86,0,6.72-4.31,11.94-10.95,11.94m.58-32.84a136.86,136.86,0,0,0-21.48,1.91v57.73h9.54V171.87a89.71,89.71,0,0,0,12.69.66c11.36,0,19-8.38,19-20.24-.24-12.44-7.13-20.65-19.74-20.65m-34.75,1.24h-9.62V164.4a82.26,82.26,0,0,1-10.87.75c-6,0-9-3.07-9-9.29v-23h-9.62V158.1c0,11,6.72,15.26,16.51,15.26a139.89,139.89,0,0,0,22.56-2.07Zm-70.84,32c-7.38,0-12.36-5.06-12.36-12.69,0-7.47,5-12.36,12.36-12.36s12.19,4.89,12.19,12.36c0,7.63-4.89,12.69-12.19,12.69m0-33.76c-13.11,0-22,8.46-22,21.07,0,12.85,8.87,21.4,22,21.4s21.9-8.55,21.9-21.4c0-12.61-8.88-21.07-21.9-21.07m-27.12.5a150.39,150.39,0,0,0-24.14,2.4V172.1h9.54V141.59c4.81-.41,9.54-.58,14.6-.58Zm-36.92,8H82.61v9.21h20.32v12.28a65.61,65.61,0,0,1-16.59,2.48c-11.78,0-19.66-8-19.66-20C66.68,131.9,75.39,124,88.5,124c3.31,0,9,.74,16.67,2.15l2-9.28a82,82,0,0,0-19.41-2.49c-18.91,0-31.52,11.69-31.52,29.19,0,17.84,12,29.7,30.11,29.7,8.21,0,17-2.24,26-6.14Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M463.84,198.09v-5.47h2.91c1.84,0,3.22.94,3.22,2.68s-1.38,2.83-3.22,2.83Zm2.59-8.7c-2.25,0-4.47.12-6.07.21v16.45h3.48v-4.84h2.59c4.12,0,6.94-2.37,6.94-6s-2.82-5.85-6.94-5.85m-28.56.21h-3.5v9.22c0,2.73-1.63,4.33-4.05,4.33s-4-1.6-4-4.33V189.6H422.8v9.22c0,4.74,3,7.59,7.52,7.59s7.55-2.85,7.55-7.59Zm-45.73,13.55a5.31,5.31,0,1,1,5.15-5.47v.14a5,5,0,0,1-4.66,5.32,4,4,0,0,1-.49,0m0-13.91c-5.16,0-8.81,3.43-8.81,8.58s3.65,8.59,8.81,8.59,8.8-3.43,8.8-8.59-3.65-8.58-8.8-8.58M352.25,198v-5.4h2.91c2,0,3.24.79,3.24,2.61a2.79,2.79,0,0,1-2.79,2.79h-3.36Zm3.05,3,3.39,5h4.2l-4.15-5.88a5.55,5.55,0,0,0,3.09-5c0-3.73-2.68-5.73-6.72-5.73-2.18,0-5.06.1-6.34.14V206h3.48v-5h3.05Zm-29-4.62h-8.81v3.12h5.59v2.9a19.23,19.23,0,0,1-4.4.63,5,5,0,0,1-5.19-4.81c0-.16,0-.33,0-.49,0-3.09,2.35-5.17,5.86-5.17a35.32,35.32,0,0,1,4.81.6l.65-3.22a25.29,25.29,0,0,0-5.75-.72c-5.54,0-9.22,3.41-9.22,8.51s3.51,8.66,8.8,8.66a20.24,20.24,0,0,0,7.65-1.79Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M3,258.77H0v-17H3Z" transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M22.47,258.77H19.62l-9.37-11.9v11.9h-3v-17H10l9.48,12v-12h3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M38.47,245.32a21.6,21.6,0,0,0-5.8-1.07c-1.92,0-3.17.72-3.17,2.22s1.55,1.88,4.3,2.43c3.72.75,6,1.8,6,4.95,0,3.57-2.83,5.29-6.78,5.29a19.32,19.32,0,0,1-7.12-1.42l.7-2.8a18.22,18.22,0,0,0,6.55,1.4c2.15,0,3.62-.65,3.62-2.17,0-2-2.5-2.28-5-2.78-3.73-.77-5.35-2-5.35-4.77,0-3.1,2.55-5.08,6.42-5.08a19.87,19.87,0,0,1,6.48,1.15Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M58,251.52c0,4.7-3,7.62-7.62,7.62s-7.63-2.92-7.63-7.62v-9.75h3v9.75c0,3,1.83,4.82,4.63,4.82S55,254.55,55,251.52v-9.75h3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M68.42,253.25H64.8v5.5h-3v-17c1.32-.05,4.1-.15,6.22-.15,4.1,0,6.83,2,6.83,5.75a5.52,5.52,0,0,1-3.45,5.15l4.52,6.25H72.27Zm-.07-2.65a3.28,3.28,0,0,0,3.56-3c0-.08,0-.16,0-.25,0-2.1-1.52-3.05-3.77-3.05-1.08,0-2.2,0-3.35.05v6.23Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M81.57,258.77h-3v-17h3Z" transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M101.05,258.77H98.2l-9.38-11.9v11.9h-3v-17H88.6l9.47,12v-12h3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M121.37,257.29a20.07,20.07,0,0,1-7.85,1.85c-5.45,0-9.07-3.57-9.07-8.94s3.8-8.8,9.5-8.8a25.08,25.08,0,0,1,5.85.75l-.6,2.8a32.43,32.43,0,0,0-5-.65c-4,0-6.57,2.37-6.57,5.9a5.65,5.65,0,0,0,5.26,6h.66a19.71,19.71,0,0,0,5-.75v-3.7H112.4V249h9Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M137.7,258.77h-3V244.55h-6.2v-2.78h15.4v2.78h-6.2Z" transform="translate(0 0)"
                              style="fill:#fff"/>
                        <path d="M163.25,250.27c0,5.33-3.75,8.87-9.05,8.87s-9.08-3.54-9.08-8.87,3.78-8.87,9.08-8.87S163.25,245,163.25,250.27Zm-3.15,0a5.92,5.92,0,1,0-5.9,6,5.71,5.71,0,0,0,5.9-5.53A3.69,3.69,0,0,0,160.1,250.27Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M177.65,258.77H175l-4.88-10.3-.67,10.3h-2.93l1-17h2.82l6,13.4,6-13.4h2.85l1,17h-3l-.68-10.3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M207.17,250.27c0,5.33-3.75,8.87-9,8.87s-9.07-3.54-9.07-8.87,3.77-8.87,9.07-8.87S207.17,245,207.17,250.27Zm-3.15,0a5.91,5.91,0,1,0-5.9,6,5.7,5.7,0,0,0,5.88-5.53,3.69,3.69,0,0,0,0-.47Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M217.07,253.25h-3.62v5.5h-3v-17c1.32-.05,4.1-.15,6.22-.15,4.1,0,6.83,2,6.83,5.75a5.52,5.52,0,0,1-3.45,5.15l4.52,6.25h-3.65ZM217,250.6a3.28,3.28,0,0,0,3.56-3c0-.08,0-.16,0-.25,0-2.1-1.52-3.05-3.77-3.05-1.08,0-2.2,0-3.35.05v6.23Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M233.85,253.25h-3.63v5.5h-3v-17c1.33-.05,4.1-.15,6.23-.15,4.1,0,6.82,2,6.82,5.75a5.5,5.5,0,0,1-3.45,5.15l4.53,6.25H237.7Zm-.08-2.65a3.29,3.29,0,0,0,3.57-3c0-.08,0-.16,0-.24,0-2.1-1.53-3.05-3.78-3.05-1.07,0-2.2,0-3.35.05v6.23Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M261,250.27c0,5.33-3.74,8.87-9,8.87s-9.08-3.54-9.08-8.87,3.78-8.87,9.08-8.87S261,245,261,250.27Zm-3.14,0a5.92,5.92,0,1,0-5.9,6,5.71,5.71,0,0,0,5.94-5.49,4.34,4.34,0,0,0,0-.51Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M278.82,258.77l-4.15-11.9-4.15,11.9h-2.85l-5.65-17h3.18l4,12.38,4.23-12.38H276l4.22,12.38,4-12.38h3.18l-5.65,17Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M308.84,258.77l-4.14-11.9-4.15,11.9H297.7l-5.65-17h3.17l4,12.38,4.22-12.38H306l4.22,12.38,4-12.38h3.17l-5.65,17Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M323,258.77h-3v-17h3Z" transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M334.27,258.77h-3V244.55h-6.2v-2.78h15.4v2.78h-6.2Z" transform="translate(0 0)"
                              style="fill:#fff"/>
                        <path d="M354.3,258.77v-6.95h-8.75v6.95h-3v-17h3v7.28h8.75v-7.28h3v17Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M380.92,245a23,23,0,0,0-4.95-.7c-4.35,0-6.65,2.52-6.65,5.92,0,3.65,2.53,6.1,6.35,6.1a26.64,26.64,0,0,0,5.33-.75l.54,2.62a22.24,22.24,0,0,1-6,.95c-5.62,0-9.37-3.54-9.37-8.89s3.75-8.85,9.42-8.85a23,23,0,0,1,5.9.77Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M401.24,250.27c0,5.33-3.74,8.87-9,8.87s-9.08-3.54-9.08-8.87,3.78-8.87,9.08-8.87S401.24,245,401.24,250.27Zm-3.15,0a5.91,5.91,0,1,0-5.89,6,5.71,5.71,0,0,0,5.89-5.52A3.84,3.84,0,0,0,398.09,250.27Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M419.74,258.77h-2.85l-9.37-11.9v11.9h-3v-17h2.78l9.47,12v-12h3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M434.92,249.57v2.78H427v6.42h-3v-17h12v2.78h-9v5Z" transform="translate(0 0)"
                              style="fill:#fff"/>
                        <path d="M441.72,258.77h-3v-17h3Z" transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M461,250.2a8.33,8.33,0,0,1-7.84,8.79,6.43,6.43,0,0,1-.76,0c-2.33,0-5.18-.1-6.43-.2v-17c1.25-.07,3.88-.22,6-.22C457.25,241.55,461,245,461,250.2Zm-3.15,0a5.57,5.57,0,0,0-5.22-5.88H452c-.93,0-2,0-3,.1v11.7c1.13.05,2.35.1,3.43.1,3,0,5.41-2.37,5.41-6Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M475.52,248.9v2.75h-8.27V256h9.32v2.78H464.25v-17h12.32v2.78h-9.32v4.35Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M495.32,258.77h-2.85l-9.37-11.9v11.9h-3v-17h2.77l9.47,12v-12h3Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M513.49,245a22.9,22.9,0,0,0-4.94-.7c-4.35,0-6.65,2.52-6.65,5.92,0,3.65,2.52,6.1,6.35,6.1a26.54,26.54,0,0,0,5.32-.75l.55,2.62a22.24,22.24,0,0,1-6,.95c-5.63,0-9.38-3.54-9.38-8.89s3.75-8.85,9.43-8.85a22.94,22.94,0,0,1,5.89.77Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                        <path d="M528.94,248.9v2.75h-8.27V256H530v2.78H517.67v-17H530v2.78h-9.32v4.35Z"
                              transform="translate(0 0)" style="fill:#fff"/>
                    </svg>
                </router-link>
                <a :href="$root.base_url + 'en/groupama_RA19-EN.pdf'" target="_blank" rel="noreferrer" class="main-nav-button">
                    <svg class="main-nav-button-icon dl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div>
                        DOWNLOAD<br> THE ANNUAL REPORT
                    </div>
                </a>
                <router-link to="/interview-des-dirigeants" class="main-nav-button">
                    <svg class="main-nav-button-icon it" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.82 28.39">
                        <path d="M25.87,16.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                        <path d="M36.6,24.51a1,1,0,0,0,.09-1.11L33.17,17A12.92,12.92,0,0,0,13.29,2.49h-.16A12.69,12.69,0,0,0,2.31,21.8L.08,27a1,1,0,0,0,1.3,1.32l5.3-2.18A12.7,12.7,0,0,0,20,25.83h.88a13,13,0,0,0,8.23-3l6.4,1.92A1,1,0,0,0,36.6,24.51ZM13.14,25.87a10.73,10.73,0,0,1-5.82-1.72,1,1,0,0,0-.92-.09L2.9,25.5l1.47-3.4a1,1,0,0,0-.09-1A10.68,10.68,0,0,1,10.91,4.72,12.91,12.91,0,0,0,12.65,22.9a13.13,13.13,0,0,0,4.17,2.31A11,11,0,0,1,13.14,25.87Zm16-5a1,1,0,0,0-1,.22,10.92,10.92,0,1,1,2.92-4.27,1,1,0,0,0,.06.84l2.55,4.59Z"/>
                        <path d="M25.87,8.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                        <path d="M25.87,12.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                    </svg>
                    <div>
                        INTERVIEW<br> OF THE LEADERS

                    </div>
                </router-link>
                <router-link
                        v-if="$route.fullPath === '/interview-des-dirigeants' || $route.fullPath === '/mentions-legales'"
                        to="/etre" class="nav-button nav-etre nav-hide-mobile">Purpose
                </router-link>
                <div v-if="$route.fullPath === '/interview-des-dirigeants' || $route.fullPath === '/mentions-legales'"
                     class="nav-line nav-hide-mobile"></div>
                <router-link
                        v-if="$route.fullPath === '/interview-des-dirigeants' || $route.fullPath === '/mentions-legales'"
                        to="/agir" class="nav-button nav-agir nav-hide-mobile">Actions
                </router-link>
            </div>
            <languages color="#ffffff" hide="list"></languages>
        </div>

        <div class="main-nav-mobile">
            <div class="main-nav-mobile-burger" :class="{ 'active' : $root.menuMobile }"
                 @click="$root.menuMobile = !$root.menuMobile">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="main-nav-mobile-container" v-if="$root.menuMobile">
                <div class="main-nav-mobile-languages">
                    <a :href="$root.base_url + 'fr' + url">FR</a>
                    <a :href="$root.base_url + 'en' + url" class="active">EN</a>
                </div>
                <a href="#"
                   @click.prevent="$route.fullPath === '/interview-des-dirigeants' || $route.fullPath === '/mentions-legales' ? push('/etre') : $root.$refs.etreAgir.fromAgirToEtre()"
                   class="main-nav-mobile-link t1">
                    Our <span>purpose</span>
                </a>
                <a href="#"
                   @click.prevent="$route.fullPath === '/interview-des-dirigeants' || $route.fullPath === '/mentions-legales' ? push('/agir') :$root.$refs.etreAgir.fromEtreToAgir()"
                   class="main-nav-mobile-link t2">
                    The reasons behind our <span>actions</span>
                </a>
                <a :href="$root.base_url + 'en/groupama_RA19-EN.pdf'" target="_blank" rel="noreferrer" class="main-nav-mobile-link t3">
                    <svg class="main-nav-button-icon dl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div>
                        DOWNLOAD<br> THE ANNUAL REPORT
                    </div>
                </a>
                <router-link to="/interview-des-dirigeants" class="main-nav-mobile-link t3">
                    <svg class="main-nav-button-icon it" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.82 28.39">
                        <path d="M25.87,16.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                        <path d="M36.6,24.51a1,1,0,0,0,.09-1.11L33.17,17A12.92,12.92,0,0,0,13.29,2.49h-.16A12.69,12.69,0,0,0,2.31,21.8L.08,27a1,1,0,0,0,1.3,1.32l5.3-2.18A12.7,12.7,0,0,0,20,25.83h.88a13,13,0,0,0,8.23-3l6.4,1.92A1,1,0,0,0,36.6,24.51ZM13.14,25.87a10.73,10.73,0,0,1-5.82-1.72,1,1,0,0,0-.92-.09L2.9,25.5l1.47-3.4a1,1,0,0,0-.09-1A10.68,10.68,0,0,1,10.91,4.72,12.91,12.91,0,0,0,12.65,22.9a13.13,13.13,0,0,0,4.17,2.31A11,11,0,0,1,13.14,25.87Zm16-5a1,1,0,0,0-1,.22,10.92,10.92,0,1,1,2.92-4.27,1,1,0,0,0,.06.84l2.55,4.59Z"/>
                        <path d="M25.87,8.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                        <path d="M25.87,12.36h-10a1,1,0,0,0,0,2h10a1,1,0,1,0,0-2Z"/>
                    </svg>
                    <div>
                        INTERVIEW<br> OF THE LEADERS
                    </div>
                </router-link>
                <div class="main-nav-mobile-socials">
                    <p class="main-nav-mobile-socials-title">
                        Follow us !
                    </p>

                    <div class="main-nav-mobile-socials-items">
                        <a href="https://www.instagram.com/groupama" target="_blank" rel="nofollow"
                           class="main-nav-mobile-socials-item instagram"
                           title="Suivez-nous sur Instagram">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                <title>Follow us on Instagram</title>
                                <path d="M128,23.06c34.18,0,38.23.13,51.72.75,12.48.57,19.26,2.65,23.77,4.41a39.66,39.66,0,0,1,14.72,9.57,39.66,39.66,0,0,1,9.57,14.72c1.76,4.51,3.84,11.29,4.41,23.77.62,13.49.75,17.54.75,51.72s-.13,38.23-.75,51.72c-.57,12.48-2.65,19.26-4.41,23.77a42.33,42.33,0,0,1-24.29,24.29c-4.51,1.76-11.29,3.84-23.77,4.41-13.49.62-17.54.75-51.72.75s-38.23-.13-51.72-.75c-12.48-.57-19.26-2.65-23.77-4.41a39.58,39.58,0,0,1-14.72-9.57,39.58,39.58,0,0,1-9.57-14.72c-1.76-4.51-3.84-11.29-4.41-23.77-.62-13.49-.75-17.54-.75-51.72s.13-38.23.75-51.72C24.38,63.8,26.46,57,28.22,52.51a39.66,39.66,0,0,1,9.57-14.72,39.58,39.58,0,0,1,14.72-9.57C57,26.46,63.8,24.38,76.28,23.81c13.49-.62,17.54-.75,51.72-.75M128,0C93.24,0,88.88.15,75.23.77S52.3,3.56,44.15,6.72A62.88,62.88,0,0,0,21.48,21.48,62.83,62.83,0,0,0,6.72,44.16C3.56,52.3,1.39,61.6.77,75.23S0,93.24,0,128s.15,39.12.77,52.77,2.79,22.93,5.95,31.08a62.88,62.88,0,0,0,14.76,22.67,62.88,62.88,0,0,0,22.67,14.76c8.15,3.16,17.45,5.33,31.08,5.95s18,.77,52.77.77,39.12-.15,52.77-.77,22.93-2.79,31.07-5.95a65.4,65.4,0,0,0,37.44-37.43c3.16-8.15,5.33-17.45,5.95-31.08s.77-18,.77-52.77-.15-39.12-.77-52.77-2.79-22.93-5.95-31.07a62.83,62.83,0,0,0-14.76-22.68A62.83,62.83,0,0,0,211.84,6.72C203.7,3.56,194.4,1.39,180.77.77S162.76,0,128,0Zm0,62.27A65.73,65.73,0,1,0,193.73,128,65.73,65.73,0,0,0,128,62.27Zm0,108.4A42.67,42.67,0,1,1,170.67,128,42.68,42.68,0,0,1,128,170.67Zm83.69-111a15.36,15.36,0,1,1-15.36-15.36A15.36,15.36,0,0,1,211.69,59.67Z"/>
                            </svg>
                        </a>
                        <a href="https://www.facebook.com/groupama" target="_blank" rel="nofollow"
                           class="main-nav-mobile-socials-item facebook" title="Suivez-nous sur Facebook">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.72 430.11"><title>Follow us on
                                Facebook</title>
                                <path d="M43.38,83.3v59.22H0v72.41H43.38V430.11h89.13V214.94h59.8s5.6-34.73,8.32-72.69H132.84V92.74c0-7.4,9.72-17.35,19.33-17.35h48.55V0h-66C41.18,0,43.38,72.48,43.38,83.3Z"/>
                            </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/groupama" target="_blank" rel="nofollow"
                           class="main-nav-mobile-socials-item linkedin"
                           title="Suivez-nous sur Linkedin">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23">
                                <title>Follow us on Linkedin</title>
                                <path d="M5,3.5A2.48,2.48,0,1,1,2.5,1,2.49,2.49,0,0,1,5,3.5ZM5,8H0V24H5Zm8,0H8V24h5V15.6c0-4.67,6-5,6,0V24h5V13.87C24,6,15.08,6.28,13,10.16Z"/>
                            </svg>
                        </a>
                        <a href="https://twitter.com/groupama" target="_blank" rel="nofollow"
                           class="main-nav-mobile-socials-item twitter"
                           title="Suivez-nous sur Twitter">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19.5">
                                <title>Follow us on Twitter</title>
                                <path d="M24,2.31a9.87,9.87,0,0,1-2.83.77A4.94,4.94,0,0,0,23.34.36a10,10,0,0,1-3.13,1.19,4.93,4.93,0,0,0-8.39,4.5A14,14,0,0,1,1.67.9,4.94,4.94,0,0,0,3.19,7.48,5,5,0,0,1,1,6.86a4.94,4.94,0,0,0,4,4.89,4.86,4.86,0,0,1-2.22.08,4.92,4.92,0,0,0,4.6,3.42,9.86,9.86,0,0,1-7.29,2A13.92,13.92,0,0,0,7.55,19.5a13.92,13.92,0,0,0,14-14.64A10.11,10.11,0,0,0,24,2.31Z"/>
                            </svg>
                        </a>
                    </div>

                </div>
            </div>
        </div>

    </nav>

</template>

<script>
    export default {
        name: "Navigation",
        computed: {
            url() {
                return this.$route.path;
            }
        },
        methods: {
            push(link) {
                this.$router.push(link);
            }
        }
    }
</script>

<style scoped lang="scss">

    .nav {
        &-line {
            width: 1px;
            background: #00352c;
            height: 34px;
            margin-right: 20px;
        }

        &-button {
            font-size: 25px;
            font-weight: 900;
            text-transform: uppercase;
            text-decoration: none;
            margin-right: 20px;
            opacity: .5;
            transition: .25s ease;
            position: relative;
            line-height: 40px;

            &:hover {
                opacity: 1;
            }

            &.nav-etre {
                color: #a1bf38;

            }

            &.nav-agir {
                color: #004135;
            }

        }
    }

    .router-link-active {
        color: #a1bf38 !important;

        .main-nav-button-icon {
            fill: #a1bf38;
        }
    }

    .main-nav {
        width: 100%;
        height: 160px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        z-index: 99;
        background: #006b58;

        &-mobile {
            display: none;
        }

        &-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0px 70px;
            margin: auto;
        }

        &-left {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &-button {
            display: flex;
            align-items: center;
            color: white;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            margin-right: 50px;
            text-decoration: none;
            line-height: 12px;
            letter-spacing: .05em;
            padding: 5px;
            transition: .25s ease;

            &:hover {
                color: #a1bf38;

                .main-nav-button-icon {
                    fill: #a1bf38;
                }
            }


            &-icon {
                width: 18px;
                height: 24px;
                fill: white;
                margin-right: 8px;
                transition: .25s ease;

                &.it {
                    width: 27px;
                    height: 21px;
                }

            }
        }

        &-logo {
            margin-right: 70px;

            svg {
                width: 149px;
                height: 72px;

                path, rect {
                    fill: white !important;
                }
            }
        }

    }

    @media screen and (max-width: 1000px) {

        .nav-hide-mobile {
            display: none;
        }

    }

    @media screen and (max-width: 780px) {

        .nav-hide-mobile {
            display: none;
        }

        .main-nav {
            height: 90px;
            position: fixed;
            z-index: 99999;
            border-bottom: 1px solid rgba(0, 0, 0, .1);
            top: 0;
            left: 0;
            right: 0;

            &-mobile {
                display: block;

                &-languages {
                    display: flex;
                    justify-content: flex-end;
                    margin-bottom: 50px;

                    a {
                        margin-right: 20px;
                        font-size: 13px;
                        color: #00352c;

                        &.active {
                            font-weight: 900;
                            text-decoration: underline;
                        }

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                &-link {
                    margin-bottom: 30px;
                    text-decoration: none;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    &.t1 {
                        color: #a1bf38;
                        line-height: 1.35;
                    }

                    &.t2 {
                        color: #003a2f;
                        line-height: 1.2;
                    }

                    &.t1, &.t2 {

                        text-transform: uppercase;
                        font-weight: 900;

                        span {
                            display: block;
                            font-size: 70px;
                        }
                    }

                    &.t3 {
                        display: flex;
                        text-decoration: none;
                        color: white;
                        align-items: center;
                        text-transform: uppercase;
                        font-size: 12px;
                        font-weight: 700;

                        svg {
                            width: 34px;
                            fill: white;
                            margin-right: 15px;
                        }

                    }
                }

                &-socials {
                    display: flex;
                    flex-direction: column;

                    &-title {
                        color: white;
                        font-size: 16px;
                        text-transform: uppercase;
                        font-weight: 600;
                    }

                    &-items {
                        display: flex;
                        align-items: flex-start;
                    }

                    &-item {
                        width: 35px;
                        height: 35px;
                        border: 1px solid white;
                        border-radius: 50%;
                        overflow: hidden;
                        display: flex;
                        margin-right: 15px;
                        text-indent: -9999px;
                        align-items: center;
                        justify-content: center;
                        transition: .25s ease;
                        box-shadow: 0 0 0px rgba(0, 0, 0, .2);

                        &:hover {
                            background: #00352c;
                            transform: scale(1.3);
                            box-shadow: 0 0 5px rgba(0, 0, 0, .2);

                            &.rss {
                                svg {
                                    path, circle {
                                        stroke: #006b58 !important;
                                    }
                                }
                            }

                            svg {
                                animation: shake infinite .3s ease;
                                fill: #006b58;


                            }
                        }

                        @keyframes shake {
                            0% {
                                transform: rotate(0deg);
                            }

                            25% {
                                transform: rotate(15deg);
                            }

                            50% {
                                transform: rotate(0);
                            }

                            75% {
                                transform: rotate(-15deg);
                            }

                            100% {
                                transform: rotate(0);
                            }
                        }


                        svg {
                            width: 15px;
                            height: 15px;
                            fill: white;
                            transform-origin: center;
                        }

                        &.print {
                            svg {
                                width: 17px;
                                height: 15px;
                            }
                        }

                        &.email {
                            svg {
                                width: 17px;
                                height: 13px;
                            }
                        }

                        &.facebook {
                            svg {
                                width: 8px;
                                height: 15px;
                            }
                        }

                        &.rss {
                            svg {
                                width: 13px;
                                height: 13px;

                                path, rect, circle {
                                    stroke: #00352c !important;
                                }
                            }
                        }

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

                &-burger {
                    width: 35px;
                    height: 29px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    position: absolute;
                    right: 15px;
                    top: 25px;
                    cursor: pointer;

                    &.active {

                        span {
                            &:nth-child(1) {
                                top: 50%;
                                left: 50%;
                                transform: rotate(45deg) translate(-50%, -50%);
                            }

                            &:nth-child(2) {
                                width: 0;
                            }

                            &:nth-child(3) {
                                top: 50%;
                                left: 50%;
                                transform: rotate(-45deg) translate(-50%, -50%);
                            }
                        }

                    }

                    span {
                        transform-origin: left top;
                        left: 0;
                        top: 0;
                        z-index: 9999;
                        position: absolute;
                        background: white;
                        height: 4px;
                        border-radius: 4px;
                        width: 100%;
                        transition: .25s ease;

                        &:nth-child(2) {
                            top: 50%;
                            transform: translateY(-50%);
                        }

                        &:nth-child(3) {
                            top: calc(100% - 4px);
                        }

                    }
                }

                &-container {
                    position: fixed;
                    z-index: 999;
                    top: 90px;
                    left: 0;
                    width: 100%;
                    height: calc(100vh - 90px);
                    background: #006251;
                    padding: 30px;
                    border-top: 1px solid rgba(0, 0, 0, .1);
                }

            }

            &-container {
                padding: 0 10px;
                justify-content: flex-start;
            }

            &-logo {
                margin-right: 0;

                svg {
                    width: 100px;
                    height: 49px;
                }

            }

            .languages {
                margin-left: 10px !important;
                margin-top: -15px !important;
            }

            &-button {
                display: none;
            }

            .hidden-xs {
                display: none;
            }

        }
    }

    @media screen and (max-width: 500px) {

        .main-nav-mobile-languages {
            margin-bottom: 0;
        }

        .main-nav {
            height: 50px;
        }

        .main-nav-logo svg {
            width: 72px;
            height: 35px;
            display: block;
        }

        .main-nav-mobile-burger {
            width: 25px;
            height: 20px;
            top: 15px;
        }

        .main-nav-mobile-container {
            top: 50px;
            height: calc(100vh - 50px);
        }

        .main-nav .languages {
            display: none;
        }

        .main-nav-mobile-container {
            overflow: auto;
        }

        .main-nav-mobile-link.t1 span, .main-nav-mobile-link.t2 span {
            font-size: 34px;
        }

        .main-nav-mobile-link.t2 span {
            margin-bottom: 20px;
        }

    }

</style>
